export const ENVIRONMENT = "PRODUCTION";

export const config =
  ENVIRONMENT === "PRODUCTION"
    ? {
        BASE_URL: "https://dentistfind.com",
        PUBLISH_KEY: "pub-c-7e87b0d4-cbe1-45a7-b6d9-881fa0d37029",
        SUBSCRIBE_KEY: "sub-c-52c261d1-db04-44a6-b369-b31b4530646b",
      }
    : {
        BASE_URL: "https://test.dentistfind.com",
        PUBLISH_KEY: "pub-c-844cc8e6-65e6-4bcd-bd02-4c50312fa841",
        SUBSCRIBE_KEY: "sub-c-f7dbbd8d-de58-48f4-b5b0-7b5ac8eb328d",
      };

export const PublicUrl =
  ENVIRONMENT === "PRODUCTION"
    ? "https://master.d13wd6j57j7ijh.amplifyapp.com/"
    : "https://integrate-api.d13wd6j57j7ijh.amplifyapp.com/";

export default config;
